import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es6.function.name.js";
import { EXPERIMENTS_SWITCH } from 'redux/actionTypes/experiments';
import { EXPERIMENT_SETTINGS_INFO_UPDATE } from 'redux/actionTypes/experimentSettings';
var switchExperiment = function switchExperiment(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var _getState$experiments, name, sampleIds, pipelineVersion, accessRole;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _getState$experiments = getState().experiments[experimentId], name = _getState$experiments.name, sampleIds = _getState$experiments.sampleIds, pipelineVersion = _getState$experiments.pipelineVersion, accessRole = _getState$experiments.accessRole;
              dispatch({
                type: EXPERIMENTS_SWITCH
              });
              dispatch({
                type: EXPERIMENT_SETTINGS_INFO_UPDATE,
                payload: {
                  experimentId: experimentId,
                  experimentName: name,
                  sampleIds: sampleIds,
                  pipelineVersion: pipelineVersion,
                  accessRole: accessRole
                }
              });
            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default switchExperiment;